import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";
import { getValueToPay } from "@CheckoutStepsOffers/utils/getValueToPay";
import { getValueToPayWithDiscount } from "@CheckoutStepsOffers/utils/getValueToPayWithDiscount";

import { Paragraph, Strong } from "./styles";

const DiscountInformation = () => {
  const { offer, coupon, installmentSelected, userCanTrial } =
    useCheckoutStepsOffersContext();

  const trialDays = offer?.offer?.details?.trial_days;

  const FREQUENCY = offer.offer.frequency;
  const MONTHS = {
    monthly: "30 dias",
    quarterly: "3 meses",
    semiannual: "6 meses",
    annual: "12 meses",
  };

  const valueToPay = getValueToPay({
    offer,
    installmentSelected: installmentSelected?.installment,
  });

  const valueToPayWithDiscount = getValueToPayWithDiscount({
    offer,
    coupon,
    installmentSelected: installmentSelected?.installment,
  });

  const IS_SUBSCRIPTION = offer?.offer?.details?.payment_type === "recurrent";
  const IS_COUPON_ON_RENEW = offer?.offer?.details?.use_coupon_on_renew;
  const TRIAL_ENABLED = offer?.offer?.details?.trial_enabled;
  const HAS_COUPON = !!coupon;

  if (!IS_SUBSCRIPTION) return null;

  if (!IS_COUPON_ON_RENEW && !!HAS_COUPON && !TRIAL_ENABLED) {
    return (
      <Paragraph>
        <Strong>
          Este é um valor promocional! Após {MONTHS[FREQUENCY]}, será cobrado{" "}
          {valueToPay}
        </Strong>{" "}
        pelo conteúdo adquirido. Você pode cancelar a qualquer momento a sua
        assinatura acessando Minhas compras.
      </Paragraph>
    );
  }

  if (TRIAL_ENABLED && HAS_COUPON && userCanTrial && !IS_COUPON_ON_RENEW) {
    return (
      <Paragraph>
        <Strong>
          Após {offer?.offer?.details?.trial_days} dias, a primeira cobrança
          será no valor promocional de {valueToPayWithDiscount}. Nas cobranças
          subsequentes, o valor da assinatura será de {valueToPay} a cada{" "}
          {MONTHS[FREQUENCY]}.
        </Strong>{" "}
        Você pode cancelar a qualquer momento a sua assinatura acessando Minhas
        compras.
      </Paragraph>
    );
  }

  if (
    (TRIAL_ENABLED && IS_COUPON_ON_RENEW && HAS_COUPON && userCanTrial) ||
    (TRIAL_ENABLED && !IS_COUPON_ON_RENEW && !HAS_COUPON && userCanTrial)
  ) {
    return (
      <Paragraph>
        <Strong>
          Não faremos nenhuma cobrança antes do fim do período gratuito.
        </Strong>{" "}
        Após {trialDays} {trialDays > 1 ? "dias" : "dia"}, você será cobrado
        para continuar tendo acesso ao conteúdo adquirido. Você pode cancelar a
        qualquer momento a sua assinatura acessando Minhas compras.
      </Paragraph>
    );
  }

  return null;
};

export default DiscountInformation;
